import { render, staticRenderFns } from "./BeancurdCube.vue?vue&type=template&id=b199dee4&scoped=true"
import script from "./BeancurdCube.vue?vue&type=script&lang=js"
export * from "./BeancurdCube.vue?vue&type=script&lang=js"
import style0 from "./BeancurdCube.vue?vue&type=style&index=0&id=b199dee4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b199dee4",
  null
  
)

export default component.exports